import renameKeyOfObjectOrSetValue from "../renameKeyOfObjectOrSetValue";
import deleteKeyOfObject from "../deleteKeyOfObject";
// Transform block tree state extract to block server api
const BlockActionExtractTransformer = (origin) => {

    const data = { ...origin };

    data.extract_output == null ? deleteKeyOfObject(data, 'extract_output') : renameKeyOfObjectOrSetValue(data, { new_key : 'extract_output' }, data.extract_output.name)
    data.extract_input  == null ? deleteKeyOfObject(data, 'extract_input')  : renameKeyOfObjectOrSetValue(data, { new_key : 'extract_input'  }, data.extract_input.name )
    
    if(data.before_after == null) {
        renameKeyOfObjectOrSetValue(data, { new_key : 'before_after' }, data.before_after.name)
    }
    renameKeyOfObjectOrSetValue(data, { new_key : 'extract_type' }, data.extract_type.name)

    return data
}

export default BlockActionExtractTransformer;